// EditProductContext.tsx
import React from 'react';

interface EditProfileContextType {
  pages: any;
  jwtToken: any;
  setPages: (pageSet: any) => void;
  setPagesDecrement: () => void;
  setPagesIncrement: () => void;
  setJwtToken: (jwtToken: any) => void;
  goBackTopreviosState: (options: any) => void;
  prevState: any;
  setUserToken: (options: any) => void;
  editProfile: (options: any) => void;
  userToken: any;
  primaryMemory: any;
}

const EditProductContext = React.createContext<EditProfileContextType | undefined>(undefined);

export default EditProductContext;
